import React from 'react';
import Header from './components/Header';
import Hero from './components/hero/Hero';
import About from './components/About';
import Services from './components/Services';
import Team from './components/Team';
import Portfolio from './components/Portfolio';
import WebsitePackages from './components/WebsitePackages';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhereWeWork from './components/locations/WhereWeWork';
import CityPage from './pages/locations/CityPage';
import { cityPages } from './data/locations';

function App() {
  const city = cityPages.find((page) => window.location.pathname === `/locations/${page.slug}`);

  if (city) {
    return (
      <div className="min-h-screen bg-dark">
        <Header />
        <CityPage city={city} />
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Portfolio />
        <WhereWeWork />
        <WebsitePackages />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;